import GitHubCalendar from "react-github-calendar";
import React from 'react';
//import ReactTooltip from "react-tooltip";
import Stats from "./Stats";
import "./CalendarStyle.css";
export const Calendar = () => {

  //blockSize={25}
  //fontSize={20}
  return (
    <div className="githubcalendar">
        <GitHubCalendar blockSize={25}
        //border:"1px solid white",padding:"2rem"
        style={{margin:"2rem auto",color:"#fff",textAlign:"center"}}
        username="rajeshdeo"
        
        >
        {/* <ReactTooltip  delayShow={20} html/> */}
        </GitHubCalendar>
        <Stats />
    </div>
  )
}
